import { createContext, useState, useEffect, useCallback } from "react";
import { Notification } from "../api";
import { useAuth } from "../hooks";

const notificationController = new Notification();

export const NotificationsContext = createContext();

/**
 * NotificationsProvider centraliza el contador de no leídas y el listado
 * corto que usa la campana (NotificationBell) en ambos layouts.
 *
 * Sin este contexto, cada layout (Admin/Student) mantenía su propio estado
 * de notificaciones, así que marcar como leída desde la página de listado
 * completo (MyNotifications / admin Notifications) no se reflejaba en la
 * campana del header hasta recargar la página. Con el estado centralizado
 * aquí, cualquier página hija puede llamar a `reloadNotifications()` tras
 * marcar/eliminar y la campana se actualiza al instante.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export function NotificationsProvider({ children }) {
  const { accessToken, user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(null);
  const [reloadTick, setReloadTick] = useState(false);

  const reloadNotifications = useCallback(() => {
    setReloadTick((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (!accessToken || !user) {
      setNotifications([]);
      setUnreadCount(null);
      return;
    }

    (async () => {
      try {
        const response = await notificationController.getNotifications();
        setNotifications(response.notifications);
        setUnreadCount(response.unreadCount);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken, user, reloadTick]);

  return (
    <NotificationsContext.Provider
      value={{ notifications, unreadCount, reloadNotifications }}
    >
      {children}
    </NotificationsContext.Provider>
  );
}
